import React from 'react'
import { Paper, Typography } from '@material-ui/core'
import ChartDonut from '../../../../components/charts/ChartDonut'
import ChartDonutSkeleton from '../../../../components/skeletons/ChartDonutSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { formatNumber } from '../../../../utils/Helpers'
// import { formatNumber, formatDateCard } from '../../../utils/Helpers'

type Props = {
  totalDeliveredGMV: number
  multipleShoppingCartDeliveredGMV: number

}
const ShoppingCartsGMV = ({ totalDeliveredGMV, multipleShoppingCartDeliveredGMV }: Props): JSX.Element => {
  if ((!totalDeliveredGMV || !multipleShoppingCartDeliveredGMV) && (totalDeliveredGMV !== 0 && multipleShoppingCartDeliveredGMV !== 0)) return <ChartDonutSkeleton />

  const labels: Array<string> = []
  const series: Array<number> = []

  labels.push('GMV geral')
  labels.push('GMV cesta simultânea')

  series.push(totalDeliveredGMV)
  series.push(multipleShoppingCartDeliveredGMV)

  const options = {
    chart: {
      id: 'shopping-carts'
    },
    labels,
    yaxis: {
      show: false
    },
    fill: {
      opacity: 1
    },
    legend: {
      formatter: function (seriesName: string, opts: any) {
        return [seriesName, ' - R$ ', formatNumber(opts.w.globals.series[opts.seriesIndex], 2, true)]
      },
      width: 260,
      height: 400
    },
    dataLabels: {
      formatter: function (value: number) {
        return `${formatNumber(value, 2)}%`
      }
    },
    tooltip: {
      y: {
        formatter: (value: number) => {
          return formatNumber(value, 2, true)
        }
      }
    }
  }

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Cestas simultâneas x Cestas Simples (geral) - GMV</Typography>
    <ChartDonut options={options} series={series} theme={ChartColumnThemes.blue} type="donut" />
  </Paper>
}

export default ShoppingCartsGMV
